import { useContext, useMemo } from 'react';
import { TagGeneratingFilesContext } from '@trinity/chat-components/containers/Workspace/context.js';
import { type Cell } from 'react-table';
import { SkeletonTags } from '@/components/presentation/Skeleton.Tags';
import { ConstrainedGroupTags } from '@/components/presentation/TruncatedTags';
import type { IFilesTable } from './interfaces';
import styles from './style/Files.Table.Cells.Tags.module.css';

export const TagsCell = ({ row: { original: data } }: Cell<IFilesTable.Item>) => {
  const tagGeneratingContext = useContext(TagGeneratingFilesContext);

  const isGenerating = useMemo(() => {
    if ('fileVersion' in data && data.fileVersion) {
      if (!data.fileVersion.generateTags) {
        return false;
      }
    }

    if ('file' in data && data.file) {
      const fileId = data.file.id;
      return tagGeneratingContext?.isGenerating(fileId);
    }

    return false;
  }, [data, tagGeneratingContext]);

  const hasTags = data.tags && data.tags.length > 0;

  if (isGenerating) {
    return (
      <div className={styles.container}>
        <SkeletonTags count={2} spinner={false} />
      </div>
    );
  }

  // If file has tags: show them
  if (hasTags) {
    return (
      <div className={styles.container}>
        <ConstrainedGroupTags tags={data.tags} maxTags={1} />
      </div>
    );
  }

  // No tags and not generating
  return (
    <div>
      <span style={{
        fontStyle: `italic`,
        color: `var(--gray-l)`,
      }}>No tags</span>
    </div>
  );
};